/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_StarterInputs */

const en_landing_pricing_starter = /** @type {(inputs: Landing_Pricing_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starter`)
};

const zh_landing_pricing_starter = /** @type {(inputs: Landing_Pricing_StarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入门版`)
};

/**
* | output |
* | --- |
* | "Starter" |
*
* @param {Landing_Pricing_StarterInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_starter = /** @type {((inputs?: Landing_Pricing_StarterInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_StarterInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_starter(inputs)
	return zh_landing_pricing_starter(inputs)
});
export { landing_pricing_starter as "landing.pricing.starter" }